// src/api/CartApi.js
import api from "../shared/AxiosConfig";

export const cartApi = {
    getCart: () => api.get("/cart"),
    addToCart: (data) => api.post("/cart", data),
    updateCartItem: (itemSlug, data) => api.put(`/cart/${itemSlug}`, data),
    removeCartItem: (data) => api.post("/cart/remove", data),
    clearCart: () => api.delete("/cart"),
};
